import { FunctionComponent, useEffect, useState } from 'react'
import { DaycareGroup, DaycareTrustee } from '@/types/DaycareGroup'
import GroupInformation from './groupInformation/groupInformation'
import AdminList from './adminList/adminList'
import DaycareAdminList from './daycareList/daycareList'
import TrusteeExports from './exports'
import { useAuth } from '@/modules/context/AuthContext'
import { Daycare } from '@/types/Daycare'
import GroupCustomization from './customization/groupCustomization'

interface GroupProfileProps {
    group?: DaycareGroup
    refetchGroups: () => void
}

const GroupProfile: FunctionComponent<GroupProfileProps> = ({ group, refetchGroups }: GroupProfileProps) => {
    const { user } = useAuth()

    const [trusteeData, setTrusteeData] = useState<DaycareTrustee[]>([])

    const [daycaresList, setDaycaresList] = useState<Array<Daycare>>([])

    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        setLoading(true)
        setDaycaresList([])
        try {
            setDaycaresList(group?.daycares || [])
        } finally {
            setLoading(false)
        }
        setTrusteeData(group?.trustees || [])
    }, [group])

    return (
        user && (
            <>
                <GroupInformation role={user.role} group={group} refetchGroups={refetchGroups} />
                <AdminList
                    role={user.role}
                    trusteeData={trusteeData}
                    groupId={group?.id || 0}
                    refetchGroups={refetchGroups}
                />
                {group && <TrusteeExports group={group} />}
                <GroupCustomization group={group} refetchGroups={refetchGroups} />
                {!loading && (
                    <DaycareAdminList
                        role={user.role}
                        daycares={daycaresList}
                        refetchGroups={refetchGroups}
                        groupId={group?.id || 0}
                    />
                )}
            </>
        )
    )
}

export default GroupProfile
